import { render, staticRenderFns } from "./CoordinationSummaryReport.vue?vue&type=template&id=32481de6&"
import script from "./CoordinationSummaryReport.vue?vue&type=script&lang=ts&"
export * from "./CoordinationSummaryReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports